import React from "react";
import Sidebar from "./Sidebar";
import publicRoutes from "../routes/contentRoutes";
import { Switch, Route, Redirect } from "react-router-dom";

export default function () {
  return (
    <div className="layout container">
      <Route path="/dao" component={Sidebar} />
      <div className="content">
        <Switch>
          {publicRoutes.map((route) => (
            <Route
              key={route.id}
              path={route.path}
              component={route.component}
              exact={route.exact}
            />
          ))}
          <Redirect to="/farm/cohort" />
        </Switch>
      </div>
    </div>
  );
}
